import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { transform } from "typescript";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "../common/common";
import {
  getLoginPageCssVars,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetBGIMageLoginImage,
  styleObjectGetColor,
  styleObjectGetLoginImage,
} from "../common/StyleSeter";
import {
  getAppLinkHref,
  getContactChannel,
  getViewAllLinksHref,
  isContactShowing,
  normalizeLoginSupportStyle,
} from "../common/loginPage";
import { notifyError, notifyMessage, postApi } from "../service";
import {
  consumeIdleLogoutHome,
  getImageUrl,
  getLoginDeviceInfo,
  isCaptchaEnabled,
  readLoginFields,
  setAuthCookie,
} from "../common/Funcation";
import instagram from "./../assets/icons/instagram.svg";
import mail from "./../assets/icons/mail.svg";
import skype from "./../assets/icons/skype.svg";
import telegram from "./../assets/icons/telegram.svg";
import whatsapp from "./../assets/icons/whatsapp.svg";
import LoginSupportSection from "../components/LoginSupportSection";
import { useCredentialAutofillLogin } from "../hooks/useCredentialAutofillLogin";
const cookies = new Cookies();

const mobileBankingLogos = [
  {
    name: "Rocket",
    key: "loginBankingRocket",
    src: `${process.env.PUBLIC_URL || ""}/images/rocket.png`,
  },
  {
    name: "bKash",
    key: "loginBankingBkash",
    src: `${process.env.PUBLIC_URL || ""}/images/bkash.png`,
  },
  {
    name: "Nagad",
    key: "loginBankingNagad",
    src: `${process.env.PUBLIC_URL || ""}/images/nagad.png`,
  },
  {
    name: "Upay",
    key: "loginBankingUpay",
    src: `${process.env.PUBLIC_URL || ""}/images/upay.png`,
  },
];

const BankingMarquee = ({ site }: { site?: any }) => {
  if (site?.loginBankingMarquee !== true) return null;

  const logos = mobileBankingLogos.map((item) => {
    const custom = String(site?.[item.key] || "").trim();
    return {
      name: item.name,
      src: custom ? getImageUrl(custom) : item.src,
    };
  });
  const marqueeItems = [...logos, ...logos, ...logos];

  return (
    <div className="login_banking_marquee" title="Accepted Mobile Banking Methods">
      <div className="login_banking_track">
        <div className="login_banking_list">
          {marqueeItems.map((item, index) => (
            <div className="login_banking_item" key={`b-orig-${index}`}>
              <img src={item.src} alt={item.name} />
            </div>
          ))}
        </div>
        <div className="login_banking_list" aria-hidden="true">
          {marqueeItems.map((item, index) => (
            <div className="login_banking_item" key={`b-dup-${index}`}>
              <img src={item.src} alt={item.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Login = (props: any) => {
  const { setOpenModal, OpenModal } = props;
  const [, updateState] = React.useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const DD = useSelector((e: any) => e.domainDetails);
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    validationCode: "",
  });

  useEffect(() => {
    if (OpenModal) return;
    if (window.location.pathname === "/login" && consumeIdleLogoutHome()) {
      navigate("/", { replace: true });
    }
  }, [navigate, OpenModal]);

  const isCaptcha = isCaptchaEnabled(DD?.captchaFrontend);
  const credentialAutofillRef = useCredentialAutofillLogin(!isCaptcha);
  const whatsappChannel = getContactChannel(DD, "whatsapp");
  const telegramChannel = getContactChannel(DD, "telegram");
  const emailChannel = getContactChannel(DD, "email");
  const skypeChannel = getContactChannel(DD, "skype");
  const instagramChannel = getContactChannel(DD, "instagram");
  const showAppLink = isContactShowing(DD, "appLink");
  const showViewAllLinks = isContactShowing(DD, "viewAllLinks");
  const SocialIcon = [
    {
      iconStatus: true,
      link: "",
      image: mail,
      name: "mail",
      showing: emailChannel.showing,
      values: emailChannel.values,
    },
    {
      iconStatus: true,
      link: "",
      image: whatsapp,
      name: "whatsapp",
      showing: whatsappChannel.showing,
      values: whatsappChannel.values,
    },
    {
      iconStatus: true,
      link: "",
      image: telegram,
      name: "telegram",
      showing: telegramChannel.showing,
      values: telegramChannel.values,
    },
    {
      iconStatus: true,
      link: "",
      image: skype,
      name: "skype",
      showing: skypeChannel.showing,
      values: skypeChannel.values,
    },
    {
      iconStatus: true,
      link: "",
      image: instagram,
      name: "instagram",
      showing: instagramChannel.showing,
      values: instagramChannel.values,
    },
  ].filter((item) => item.showing);
  const [confirmationCode, setConfirmationCode] = useState(
    Math.floor(1000 + Math.random() * 9000),
  );
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const [support, setSupport] = useState(
    process.env.REACT_APP_WHATSAPP === "true"
      ? "whatsapp"
      : process.env.REACT_APP_EMAIL === "true"
        ? "email"
        : process.env.REACT_APP_TELEGRAM === "true"
          ? "telegram"
          : process.env.REACT_APP_SKYPE === "true"
            ? "skype"
            : process.env.REACT_APP_INSTAGRAM === "true"
              ? "instagram"
              : "whatsapp",
  );
  // console.log("fffffffffffff : ", loginBackGroundColor(DD?.colorSchema));

  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();
    if (isSubmittingRef.current) {
      return;
    }
    const { username, password } = readLoginFields(e, formData);
    if (username !== formData.username || password !== formData.password) {
      setFormData({ ...formData, username, password });
    }
    if (
      username &&
      password &&
      (confirmationCode === parseInt(formData.validationCode) || !isCaptcha)
    ) {
      setIsValidationWrong(false);
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      const deviceInfo = getLoginDeviceInfo();

      let data = {
        api: USER_API.LOGIN,
        value: {
          user_name: username,
          password,
          domain: window.location.hostname,
          systemDetail: deviceInfo.systemDetail,
          browser_detail: deviceInfo.browser_detail,
        },
      };

      await postApi(data)
        .then(function (loginData) {
          if (loginData) {
            //  notifyMessage(loginData.data.message)

            // console.log("::::::::;", loginData);
            let HeaderData = {
              ...loginData.data.data.roleAccess,
              user_name: loginData.data.data.user_name,
              remaining_balance: loginData.data.data?.balance,
              ...loginData.data.data,
            };
            dispatch({ type: "HEADER_DETAILS", payload: HeaderData });
            setAuthCookie(loginData.data.data.token);
            dispatch({
              type: "AUTHENTICATION",
              payload: {
                isLogin: true,
                token: loginData.data.data.token,
                changePassword: loginData.data.data.newPassword,
              },
            });
            if (setOpenModal) {
              setOpenModal(false);
            }
            if (loginData.data.data.newPassword === true) {
              navigate("/change/password");
            }
          }
        })
        .catch((err) => {
          notifyError(
            err?.response?.data?.message || "Login failed. Please try again.",
          );
          setIsValidationWrong(false);
          setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
          setFormData((current) => ({ ...current, validationCode: "" }));
        })
        .finally(() => {
          isSubmittingRef.current = false;
          setIsSubmitting(false);
        });
    } else {
      Validator.current.showMessages();
      if (confirmationCode !== parseInt(formData.validationCode)) {
        setIsValidationWrong(true);
      }
      forceUpdate();
      setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
    }
  };

  const downloadApp = () => {
    const href = getAppLinkHref(DD);
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };
  const openViewAllLinks = () => {
    const href = getViewAllLinksHref(DD);
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    }),
  );

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 992) {
        navigate("/");
      }
    }

    window.addEventListener("resize", handleResize);
    const loginVars = getLoginPageCssVars(DD);
    Object.entries(loginVars).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [DD, navigate]);

  const loginCssVars = getLoginPageCssVars(DD);
  const loginSupportStyle = normalizeLoginSupportStyle(DD?.loginSupportStyle);
  const showExtraMob = isContactShowing(DD, "extraMob");

  return (
    <>
      <style>
        {`
      @media screen and (max-width: 576px) {
    .footer_support .extend-btn {
        padding: 8px;
    }
}
      `}
      </style>
      {/* {console.log("DD", DD)} */}
      {OpenModal ? (
        <div
          className={`${window.location.pathname === "/login" ? "login-screen" : ""
            } login_main login_main_absolute`}
          style={loginCssVars as React.CSSProperties}
        >
          <div
            className={`${window.location.pathname === "/login" ? "login-screen" : ""
              } login_main_popup`}
            style={styleObjectGetBG(DD?.colorSchema)}
          >
            <div
              className="login_popup_image"
              style={styleObjectGetLoginImage(DD?.loginImage) || {}}
            ></div>
            <div className="login_form_main">
              {window.location.pathname === "/login" ? (
                <a
                  id="close"
                  className="close"
                  onClick={() => navigate("/")}
                ></a>
              ) : (
                <a
                  id="close"
                  className="close"
                  onClick={() => setOpenModal(false)}
                ></a>
              )}
              {/* <h3 style={styleObjectGetColor(DD?.colorSchema)} className="form_title"> Please login to continue </h3> */}
              <form ref={credentialAutofillRef} className="login_form" onSubmit={(e) => handelSubmit(e)}>
                <InputGroup
                  name="username"
                  value={formData.username}
                  type="text"
                  onChange={handelInputChange}
                  placeholder="Username"
                  errorValidation={Validator.current.message(
                    "userName",
                    formData.username,
                    "required",
                  )}
                />
                <InputGroupPass
                  name="password"
                  value={formData.password}
                  type="password"
                  onChange={handelInputChange}
                  placeholder="Password"
                  errorValidation={Validator.current.message(
                    "password",
                    formData.password,
                    "required",
                  )}
                />
                {isCaptcha && (
                  <div className="validation">
                    <InputGroup
                      name="validationCode"
                      value={formData.validationCode}
                      type="number"
                      onChange={handelInputChange}
                      placeholder="Valida tion Code"
                      errorValidation={Validator.current.message(
                        "validationCode",
                        formData.validationCode,
                        "required",
                      )}
                    />
                    <div
                      style={styleObjectGetColor(DD?.colorSchema)}
                      className="validation_code"
                    >
                      <h3>{confirmationCode}</h3>
                    </div>
                  </div>
                )}

                {isValidationWrong ? (
                  <span className="error" style={{ color: "red" }}>
                    invalid verification code
                  </span>
                ) : (
                  ""
                )}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  onSubmit={(e) => handelSubmit(e)}
                >
                  {isSubmitting ? "Logging in..." : "Login"}
                  <span />
                </button>
              </form>
              {/* <BankingMarquee /> */}
            </div>
            {window.location.pathname === "/login" && (
              <div className="login_footer mobile_view">
                <div className="login_footer_social">
                  {SocialIcon.map((item) => (
                    <div className="social_icon">
                      <img src={item.image} alt={item.name} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          {window.location.pathname === "/login" && (
            <div className="login_footer">
              <div className="login_footer_social">
                {SocialIcon.map((item) => (
                  <div className="social_icon">
                    <img src={item.image} alt={item.name} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className={`${window.location.pathname === "/login" ? "login-screen" : ""
            } login_main mobile_screen backGround${loginSupportStyle === "skysupport" ? " is-skysupport" : ""}`}
          style={loginCssVars as React.CSSProperties}
        // style={styleObjectGetBG(DD?.colorSchema)}
        // style={loginBackGroundColor(DD?.colorSchema)}
        >
          <div
            className={`${window.location.pathname === "/login" ? "login-screen" : ""
              } login_main_popup`}
          // style={loginBackGroundColor(DD?.colorSchema)}
          >
            <div
              className="login_popup_image"
              style={
                styleObjectGetBGIMageLoginImage(DD?.mobileLoginImage) || {}
              }
            ></div>
            <div className="login_form_main">
              {window.location.pathname === "/login" ? (
                <a
                  id="close"
                  className="close"
                  onClick={() => navigate("/")}
                ></a>
              ) : (
                <a
                  id="close"
                  className="close"
                  onClick={() => setOpenModal(false)}
                ></a>
              )}
              {/* <h3 style={styleObjectGetColor(DD?.colorSchema)} className="form_title"> Please login to continue </h3> */}
              <form ref={credentialAutofillRef} className="login_form" onSubmit={(e) => handelSubmit(e)}>
                <InputGroup
                  name="username"
                  value={formData.username}
                  type="text"
                  onChange={handelInputChange}
                  placeholder="Username"
                  errorValidation={Validator.current.message(
                    "userName",
                    formData.username,
                    "required",
                  )}
                />
                <InputGroupPass
                  name="password"
                  value={formData.password}
                  type="password"
                  onChange={handelInputChange}
                  placeholder="Password"
                  errorValidation={Validator.current.message(
                    "password",
                    formData.password,
                    "required",
                  )}
                />
                {isCaptcha && (
                  <div className="validation">
                    <InputGroup
                      name="validationCode"
                      value={formData.validationCode}
                      type="number"
                      onChange={handelInputChange}
                      placeholder="Validation Code"
                      errorValidation={Validator.current.message(
                        "validationCode",
                        formData.validationCode,
                        "required",
                      )}
                    />
                    <div
                      style={styleObjectGetColor(DD?.colorSchema)}
                      className="validation_code"
                    >
                      <h3>{confirmationCode}</h3>
                    </div>
                  </div>
                )}
                {isValidationWrong ? (
                  <span className="error" style={{ color: "red" }}>
                    invalid verification code
                  </span>
                ) : (
                  ""
                )}
                <button
                  type="submit"
                  className="login_submit_btn"
                  disabled={isSubmitting}
                  onSubmit={(e) => handelSubmit(e)}
                >
                  {isSubmitting ? "Logging in..." : "Login"}
                  <span />
                </button>
                {(showAppLink || showViewAllLinks) && (
                  <>
                    <style>
                      {`
                    .login_main .login_main_popup .login_form_main .login_form .login_download_row--pair .login_download_btn svg {
                          left: 5px;
                          width: 22px;
                          height: 22px;
                      }
                    .login_main .login_main_popup .login_form_main .login_form .login_download_row--pair .login_download_btn h5 {
                          font-size: 12px !important;
                      }
                    `}
                    </style>
                    <div
                      className={`login_download_row${showAppLink && showViewAllLinks
                        ? " login_download_row--pair"
                        : ""
                        }`}
                    >
                      {showAppLink && (
                        <button
                          type="button"
                          className="login_download_btn login_download_btn--animated"
                          onClick={downloadApp}
                          style={{ height: "40px" }}
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0 0 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 0 0 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
                          </svg>
                          <h5>| Download App</h5>
                        </button>
                      )}
                      {showViewAllLinks && (
                        <button
                          type="button"
                          className="login_download_btn login_download_btn--animated"
                          onClick={openViewAllLinks}
                          style={{ height: "40px" }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="25" height="25" viewBox="0 0 512 512" style={{ rotate: "90deg" }}
                          >
                            <g id="XMLID_2_">
                              <path id="XMLID_7_" d="M341.2,0.3c-17,1.7-35.8,10.2-50.3,24.7L233,82.1c-29,29-36.6,75-12.8,98.8l6,6L331,81.2   c6.8-6.8,17-6.8,23.8-0.9l75,75c6.8,6.8,6.8,17-0.9,23.8L324.1,284.8l6,6c23.8,23.8,69,17,98.8-12.8l57.1-57.9   c29-29,34.1-72.4,10.2-96.2l-109-108.2C375.2,3.7,358.2-1.4,341.2,0.3L341.2,0.3z M304.5,159.6c-6.8,0-13.6,2.6-19.6,7.7   L168.3,284.8c-11.1,11.1-11.1,28.1,0,39.2l19.6,19.6c11.1,11.1,28.1,11.1,39.2,0L344.6,226c11.1-11.1,11.1-28.1,0-39.2l-20.4-18.7   C319,162.2,312.2,159.6,304.5,159.6z M147.8,206.4c-21.3-0.9-46.8,8.5-64.7,26.4L26,290.8c-29,29-34.1,72.4-10.2,96.2l109.9,109.9   c23.8,23.8,66.4,18.7,96.2-10.2l57.9-57.1c29-29,36.6-75,12.8-98.8L285,324L180.2,429.6c-6.8,6.8-17,6.8-23.8,0l-75-75   c-6.8-6.8-6.8-17,0-23.8l106.5-103.9l-6-6C172.5,211.6,161.5,207.3,147.8,206.4L147.8,206.4z" />
                            </g>
                          </svg>
                          <h5>| View All Links</h5>
                        </button>
                      )}
                    </div>
                    <span className="login_download_mark" />
                  </>
                )}
              </form>
              <BankingMarquee site={DD} />
            </div>
          </div>
          {window.location.pathname === "/login" && (
            <div
              className="login_footer"
            // style={loginBackGroundColor(DD?.colorSchema)}
            >
              <div className="footer">
                <LoginSupportSection />

                {
                  // (process.env.REACT_APP_WHATSAPP === "true" || process.env.REACT_APP_EMAIL === "true" || process.env.REACT_APP_TELEGRAM === "true" || process.env.REACT_APP_SKYPE === "true" || process.env.REACT_APP_INSTAGRAM === "true")
                  false && (
                    <div className="social_tab">
                      <div className="row">
                        <div className="col-12 support-wrap">
                          <ul
                            className="nav nav-pills"
                            id="pills-tab"
                            role="tablist"
                            data-mouse="hover"
                          >
                            {process.env.REACT_APP_WHATSAPP !== "false" && (
                              <li className="nav-item">
                                <a
                                  onMouseEnter={() => setSupport("whatsapp")}
                                  className={` nav-link ${support === "whatsapp" ? "open" : ""} `}
                                  id="pills-whatsappp"
                                  data-toggle="pill"
                                  href="#pills-whatsapp"
                                  role="tab"
                                  aria-controls="pills-whatsapp"
                                  aria-selected="false"
                                >
                                  <img src="./images/whatsapp.svg" alt="" />
                                </a>
                              </li>
                            )}
                            {process.env.REACT_APP_EMAIL !== "false" && (
                              <li className="nav-item">
                                <a
                                  onMouseEnter={() => setSupport("email")}
                                  className={` nav-link ${support === "email" ? "open" : ""} `}
                                  id="pills-mail"
                                  data-toggle="pill"
                                  href="#pills-mail"
                                  role="tab"
                                  aria-controls="pills-mail"
                                  aria-selected="true"
                                >
                                  <img src="./images/supportemail.svg" alt="" />
                                </a>
                              </li>
                            )}
                            {process.env.REACT_APP_TELEGRAM !== "false" && (
                              <li className="nav-item">
                                <a
                                  onMouseEnter={() => setSupport("telegram")}
                                  className={` nav-link ${support === "telegram" ? "open" : ""} `}
                                  id="pills-telegram-tab"
                                  data-toggle="pill"
                                  href="#pills-telegram"
                                  role="tab"
                                  aria-controls="pills-telegram"
                                  aria-selected="false"
                                >
                                  <img src="./images/telegram.svg" alt="" />
                                </a>
                              </li>
                            )}
                            {process.env.REACT_APP_SKYPE !== "false" && (
                              <li className="nav-item">
                                <a
                                  onMouseEnter={() => setSupport("skype")}
                                  className={` nav-link ${support === "skype" ? "open" : ""} `}
                                  id="pills-skyep-tab"
                                  data-toggle="pill"
                                  href="#pills-skyep"
                                  role="tab"
                                  aria-controls="pills-skyep"
                                  aria-selected="false"
                                >
                                  <img src="./images/skype.svg" alt="" />
                                </a>
                              </li>
                            )}
                            {process.env.REACT_APP_INSTAGRAM !== "false" && (
                              <li className="nav-item">
                                <a
                                  onMouseEnter={() => setSupport("instagram")}
                                  className={` nav-link ${support === "instagram" ? "open" : ""} `}
                                  id="pills-insta-tab"
                                  data-toggle="pill"
                                  href="#pills-insta"
                                  role="tab"
                                  aria-controls="pills-insta"
                                  aria-selected="false"
                                >
                                  <img src="./images/instagram.svg" alt="" />
                                </a>
                              </li>
                            )}
                          </ul>
                          <div className="support-info">
                            <div
                              id="supportDetail_whatsapp"
                              className={` support-detail ${support === "whatsapp" ? "open" : ""} `}
                            >
                              {DD
                                ? DD.whatsapp &&
                                DD.whatsapp.map((item: any) => (
                                  <a>
                                    <span>{item}</span>
                                  </a>
                                ))
                                : ""}
                            </div>
                            <div
                              id="supportDetail_email"
                              className={` support-detail ${support === "email" ? "open" : ""} `}
                            >
                              {" "}
                              {DD
                                ? DD.email &&
                                DD.email.map((item: any) => (
                                  <a href={`mailto:${item}`}>{item}</a>
                                ))
                                : ""}
                            </div>
                            <div
                              id="supportDetail_telegram"
                              className={` support-detail ${support === "telegram" ? "open" : ""} `}
                            >
                              {DD
                                ? DD.telegram &&
                                DD.telegram.map((item: any) => (
                                  <a>
                                    <span>{item}</span>
                                  </a>
                                ))
                                : ""}
                            </div>
                            <div
                              id="supportDetail_skype"
                              className={` support-detail ${support === "skype" ? "open" : ""} `}
                            >
                              {" "}
                              {DD
                                ? DD.skype &&
                                DD.skype.map((item: any) => (
                                  <a href={`unsafe:skype:${item}?chat`}>
                                    {item}
                                  </a>
                                ))
                                : ""}
                            </div>
                            <div
                              id="supportDetail_instagram"
                              className={` support-detail ${support === "instagram" ? "open" : ""} `}
                            >
                              {" "}
                              {DD
                                ? DD.instagram &&
                                DD.instagram.map((item: any) => (
                                  <a target="_blank" className="ui-link">
                                    {item}
                                  </a>
                                ))
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          )}
          <style>
            {`
            .power-mob-wrap-b img {
                width: 26.6666666667vw;
                height: 4.2666666667vw;
                background-size: contain;
                opacity: .5;
                vertical-align: middle;
                border-style: none;
            }
                .extra-mob-wrap div {
    margin-right: 2.6666666667vw;
}
    .power-mob-wrap-b {
    width: 30.6666666667vw;
    height: 11.6vw;
    border: 1px solid rgba(126, 100, 100, .4);
    border-radius: 2.1333333333vw;
    padding: .8vw 1.8666666667vw 1.6vw;
    margin-bottom: 2.6666666667vw;
    line-height: 15px;
}
    .power-mob-wrap-b {
    display: none;
    background-color: #ffffff4d;
    border-color: #0000004d;
    color: #00000080;
}
    .extra-mob-wrap div:last-of-type {
    margin-right: 0;
}
    .appdl-link-android, .appdl-link-ios {
    display: none;
    margin-bottom: 8vw;
    color: #666;
    font-size: 2.6666666667vw;
    text-align: center;
}
    .extra-mob-wrap a {
    text-decoration: none;
    color: #2789ce;
    outline: none;
    hlbr: expression(this.onFocus=this.blur());
}
    .appdl-link-android img, .appdl-link-ios img {
    width: 41.3333333333vw;
    height: auto;
}
a img {
    border: 0px solid #fff;
}
            `}
          </style>
          {showExtraMob && (
          <div style={{ display: "flex", justifyContent: "center" }} className="extra-mob-wrap">
            <div style={{ display: "block" }} className="power-mob-wrap-b">
              <span style={{ fontSize: "2.6666666667vw", fontWeight: 400 }}>Powered by</span>
              <img src="/images/logo-betfair.svg" alt="" />
            </div>
            <div className="appdl-link-android" style={{ display: "block" }}>
              <a>
                <img src="/images/btn-appdl.png" alt="" /></a>
              <p style={{ marginBottom: "7px", marginTop: 0, fontSize: "2.6666666667vw", lineHeight: "30px" }}>v1.11 - 2022-03-23 - 3.1MB </p>
            </div>
          </div>
          )}
        </div>
      )}

    </>
  );
};

export default Login;

export const InputGroup = (props: any) => {
  const { type, placeholder, name, value, onChange, errorValidation } = props;
  return (
    <div className="input_group">
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        autoComplete={
          name === "password"
            ? "current-password"
            : name === "username" || name === "user_name"
              ? "username"
              : undefined
        }
        disabled={props.disabled}
      />
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};
export const InputGroupPass = (props: any) => {
  const { type, placeholder, name, value, onChange, errorValidation } = props;
  const [showPass, setShowPass] = useState(false);
  return (
    <div className="input_group">
      <div style={{ position: "relative" }}>
        <input
          type={showPass ? "text" : type}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          placeholder={placeholder}
          autoComplete="current-password"
          disabled={props.disabled}
        />
        <span
          onClick={() => setShowPass(!showPass)}
          style={{
            position: "absolute",
            right: "5px",
            top: "50%",
            transform: "translate(0, -50%)",
            cursor: "pointer",
          }}
        >
          {showPass ? (
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M1 12s4-7.5 11-7.5S23 12 23 12s-4 7.5-11 7.5S1 12 1 12z" />
              <circle cx="12" cy="12" r="3.5" />
            </svg>
          ) : (
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M1 12s4-7.5 11-7.5S23 12 23 12s-4 7.5-11 7.5S1 12 1 12z" />
              <circle cx="12" cy="12" r="3.5" />
              <line x1="21" y1="3" x2="3" y2="21" />
            </svg>
          )}
        </span>
      </div>
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};